import React from 'react';
import { X, RotateCcw, Sparkles } from 'lucide-react';
import { avatarGradient } from './coryStyles';

export const CoryHeader = ({ onNewSession, onClose, status, onUpgrade }) => (
  <div className="flex items-center justify-between px-5 py-3.5 border-b border-border/40 shrink-0">
    <div className="flex items-center gap-3">
      <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={avatarGradient}>
        <span
          className="text-white font-bold text-sm"
          style={{ textShadow: '0 0 8px rgba(129,140,248,0.5)' }}
        >
          C
        </span>
      </div>
      <div>
        <h3 className="text-sm font-display font-semibold text-foreground tracking-tight leading-none">Cory</h3>
        <p className="text-[11px] text-muted-foreground mt-0.5">Corvana AI</p>
      </div>
    </div>
    <div className="flex items-center gap-1.5">
      {status && (
        status.is_paid ? (
          <span
            data-testid="cory-tier-badge"
            className="hidden sm:inline-flex items-center gap-1 px-2 py-1 rounded-full bg-gradient-to-r from-indigo-500 to-purple-600 text-white text-[10px] font-semibold"
          >
            <Sparkles className="w-3 h-3" /> Pro
          </span>
        ) : (
          <button
            type="button"
            data-testid="cory-header-upgrade"
            onClick={onUpgrade}
            className="hidden sm:inline-flex items-center gap-1 px-2.5 py-1 rounded-full border border-indigo-200 bg-indigo-50 text-indigo-700 text-[10px] font-semibold hover:bg-indigo-100 transition-colors"
            title="Upgrade to Cory Pro"
          >
            <Sparkles className="w-3 h-3" /> Upgrade
          </button>
        )
      )}
      <button
        data-testid="cory-new-session"
        onClick={onNewSession}
        className="p-2 rounded-xl text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
        title="New conversation"
      >
        <RotateCcw className="w-4 h-4" />
      </button>
      <button
        data-testid="cory-close"
        onClick={onClose}
        className="p-2 rounded-xl text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  </div>
);
